<div class="card border-0 shadow-sm mb-4 position-relative">
  <div class="page-disable-overlay bg-dark opacity-50 position-absolute w-100 h-100 top-0 start-0">
  </div>
  <div class="card-header bg-info bg-gradient text-white">
    <h5 class="card-title mb-0">
      <i class="fa fa-envelope me-2"></i>
      Email Configuration
    </h5>
  </div>
  <div class="card-body">
    <form class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">SMTP Server</label>
        <input type="text" class="form-control" placeholder="smtp.gmail.com">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">SMTP Port</label>
        <input type="number" class="form-control" placeholder="587">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Email Username</label>
        <input type="email" class="form-control" placeholder="noreply@example.com">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Email Password</label>
        <input type="password" class="form-control" placeholder="••••••••">
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="enableSsl">
          <label class="form-check-label" for="enableSsl">
            Enable SSL/TLS Encryption
          </label>
        </div>
      </div>
      <div class="col-12">
        <button type="submit" class="btn btn-info me-2">
          <i class="fa fa-save me-1"></i>
          Save Configuration
        </button>
        <button type="button" class="btn btn-outline-secondary">
          <i class="fa fa-paper-plane me-1"></i>
          Test Email
        </button>
      </div>
    </form>
  </div>
</div>
